import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { getChildNodes as $c5a24bc478652b5f$export$1005530eda016c13 } from "./getChildNodes.module.js";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $453cc9f0df89c0a5$var$cache = new WeakMap();

function $453cc9f0df89c0a5$export$77d5aafae4e095b2(collection) {
  var count = $453cc9f0df89c0a5$var$cache.get(collection);
  if (count != null) return count; // TS isn't smart enough to know we've ensured count is a number, so use a new variable

  var counter = 0;

  var _countItems = function countItems(items) {
    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item.type === 'section') _countItems((0, $c5a24bc478652b5f$export$1005530eda016c13)(item, collection));else counter++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  _countItems(collection);

  $453cc9f0df89c0a5$var$cache.set(collection, counter);
  return counter;
}

export { $453cc9f0df89c0a5$export$77d5aafae4e095b2 as getItemCount };